import React, { useState, useRef } from 'react'
import { Modal, ModalFooter, Button, Form } from "react-bootstrap"

export default function CAMenuView({
  me,
  isTrashed,
  toggleIsTrashed,
  downloadCorporateSingleChatCSV,
  sendAnnouncementToEventUser,
  showInviteBackButton,
}) {
  const DEFAULT_INVITE_MESSAGE = `${me.displayName} (${me.pages[0].corporateOrganization.name}) has invited you to a private chat.`
  const [show, setShow] = useState(false)
  const [inviteMessage, setInviteMessage] = useState(DEFAULT_INVITE_MESSAGE)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  function sendMessage(e) {
    e.preventDefault()
    sendAnnouncementToEventUser(inviteMessage)
    handleClose()
    setInviteMessage(DEFAULT_INVITE_MESSAGE)
  }

  return (
    <div className="btn-group dropup caret-off moderator-menu-wrapper">
      <button type="button" className="btn p-0 moderator-menu-button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <img
          src='/assets/moderatormenugray.svg'
          alt=''
          width="25"
          height="4"
        />
      </button>

      {
        <div className="dropdown-menu corporate-dropdown custom-dropdown">
          <button type="button" onClick={toggleIsTrashed} className="dropdown-item" >
            <u>{isTrashed ? "Restore" : "Trash"}</u>
          </button>
          <button type="button" onClick={downloadCorporateSingleChatCSV} className="dropdown-item">
            <u>Export chat as CSV</u>
          </button>
          {showInviteBackButton && (
            <button type="button" onClick={handleShow} className="dropdown-item">
              <u>Invite back</u>
            </button>
          )}
        </div>
      }

      <Modal className="agent-invite-message-modal" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send invite message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={sendMessage}>
            <div contentEditable='true' className='invite-message-input' onInput={e => setInviteMessage(e.target.innerText)}>{DEFAULT_INVITE_MESSAGE}</div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={sendMessage}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  )
}
